import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLocation } from 'wouter';
import { ArrowLeft, BarChart3, Shield } from 'lucide-react';
import { AnalyticsDashboard } from '@/components/analytics/AnalyticsDashboard';

export default function Analytics() {
  const { user, isAuthenticated } = useAuth();
  const [, navigate] = useLocation();
  const isAdmin = user?.role === 'admin';

  // Redirect non-admin users
  if (!isAuthenticated || !isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Shield className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-foreground mb-2">Acceso Restringido</h2>
          <p className="text-muted-foreground mb-4">
            Solo los administradores pueden acceder a esta página.
          </p>
          <button
            onClick={() => navigate('/')}
            className="btn-primary flex items-center gap-2 mx-auto"
          >
            <ArrowLeft size={16} />
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background pt-16">
      {/* Header */}
      <div className="bg-card border-b border-border sticky top-16 z-40">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="btn-secondary flex items-center gap-2"
              >
                <ArrowLeft size={16} />
                Volver
              </button>
              <div className="h-6 w-px bg-border"></div>
              <div>
                <h1 className="text-lg font-semibold text-foreground">Analytics Dashboard</h1>
                <p className="text-sm text-muted-foreground">
                  Métricas y comportamiento de usuarios
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full">
                <BarChart3 size={16} />
                <span className="text-sm font-medium">Admin Only</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Analytics Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-7xl mx-auto">
          <AnalyticsDashboard />
        </div>
      </div>
    </div>
  );
} 